import { match } from "ts-pattern";
import { capitalize } from "../utils/strings";
import styles from "./Backgrounds.module.scss";
import { colors } from "@silversea-ssc/design-system-tokens";

type BaseBackgroundColor =
  | "transparent"
  | "white"
  | "neutral01"
  | "neutral05"
  | "neutral10"
  | "neutral15"
  | "neutral35"
  | "neutral60"
  | "titanium"
  | "titaniumDark";

type ProductTypeColor =
  | "productTypeColor01"
  | "productTypeColor02"
  | "productTypeColor03"
  | "productTypeColor04";

export type BackgroundColor = BaseBackgroundColor | ProductTypeColor;

export const classForBackground = (
  backgroundColor: BackgroundColor | undefined
): string => {
  if (!backgroundColor) return styles.backgroundTransparent;

  const cssKey = `background${capitalize(backgroundColor)}`;
  return styles[cssKey];
};

export const cssVariableForColor = (color: BackgroundColor) =>
  match(color)
    .with("productTypeColor01", () => "var(--product-type-color-01)")
    .with("productTypeColor02", () => "var(--product-type-color-02)")
    .with("productTypeColor03", () => "var(--product-type-color-03)")
    .with("productTypeColor04", () => "var(--product-type-color-04)")
    .with("titaniumDark", () => colors["titanium-dark"])
    .with("transparent", () => "transparent")
    .otherwise((c) => colors[c]);

export const cssVariableForInvertedColor = (color: BackgroundColor) =>
  match(color)
    .with("titaniumDark", "titanium", "neutral60", () => colors["white"])
    .otherwise((_c) => colors["titanium"]);

export const expeditionColor04 = () => colors["expedition04"];
